import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AIRobotProject: React.FC = () => {
  const navigate = useNavigate();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      overflow: 'auto',
      padding: '1rem'
    }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
          <button
          onClick={() => navigate('/class-materials/materials')}
            style={{
              marginRight: '1rem',
              padding: '0.5rem 1rem',
              border: '1px solid #ddd',
              borderRadius: '4px',
              backgroundColor: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← 돌아가기
          </button>
          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 600 }}>AI 로봇 제작 프로젝트</h1>
        </div>
        
        <div style={{ marginBottom: '1rem', border: '1px solid #ccc', padding: '0.8rem', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontWeight: 'bold', marginBottom: '1rem', margin: '0 0 1rem 0' }}>
            📚 목차
          </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
              <a href="#AI 로봇 제작 프로젝트 개요" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                AI 로봇 제작 프로젝트 개요
              </a>
            </li>
            <li style={{marginBottom: '8px'}}>
              <a href="#프로젝트 목표" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                프로젝트 목표
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
              <a href="#필요한 재료" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                필요한 재료
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
              <a href="#프로젝트 진행 순서" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                프로젝트 진행 순서
            </a>
          </li>
            <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '6px' }}>
              <li style={{ marginBottom: '3px' }}>
                <a href="/class-materials/Microbit/PCA9685" style={{ textDecoration: 'none', color: '#555' }}>
                  1. 서보모터 초기 각도 설정 & 로봇 전진 테스트하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="/class-materials/Microbit/PoseLearningAI" style={{ textDecoration: 'none', color: '#555' }}>
                  2. 포즈학습 AI 모델 준비하기
                </a>
              </li>
              <li style={{ marginBottom: '3px' }}>
                <a href="/class-materials/Microbit/AIRobotControl" style={{ textDecoration: 'none', color: '#555' }}>
                  3. AI 모델 연동 후 로봇 주행 테스트하기
                </a>
              </li>
            </ul>
          <li style={{marginBottom: '8px'}}>
              <a href="#평가 기준" style={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
                평가 기준
            </a>
          </li>
        </ul>
        </div>
        
        <div style={{ display: 'flex', alignItems: 'end', marginBottom: '1rem', gap: '1rem' }}>
          <p style={{ color: '#666', margin: 0 }}>
            본 프로젝트는 이동할 수 있는 로봇의 구조를 설계하고 Micro:bit와 AI 모델을 활용하여 로봇을 조종하는 프로젝트로 협업능력, 의사소통 능력 및 기술적 문제해결능력을 기르기 위해 설계된 프로젝트입니다.
          </p>
        </div>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="AI 로봇 제작 프로젝트 개요">
          🤖 AI 로봇 제작 프로젝트 개요
        </h2>
        <p style={{ color: '#666', marginBottom: '1rem' }}>
          AI 로봇 제작 프로젝트는 Micro:bit와 AI 모델을 활용하여 사용자의 포즈를 인식하고 
          그에 따라 로봇을 자동으로 제어하는 프로젝트입니다. 컴퓨터 비전과 머신러닝 기술을 
          실제 하드웨어와 연동하여 실무에 적용 가능한 기술을 학습할 수 있습니다.
        </p>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="프로젝트 목표">
          🎯 프로젝트 목표
        </h2>
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f0f8ff', marginBottom: '1rem' }}>
          <ul style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li>Micro:bit와 서보모터를 활용한 로봇 제어 시스템 구축</li>
            <li>AI 포즈 인식 모델 개발 및 훈련</li>
            <li>실시간 AI 모델과 하드웨어 연동</li>
            <li>무선 통신을 통한 로봇 원격 제어</li>
            <li>창의적 문제해결 능력 및 협업 능력 향상</li>
          </ul>
        </div>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="필요한 재료">
          🛠️ 필요한 재료
        </h2>
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f0f8ff', marginBottom: '1rem' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#1976d2' }}>하드웨어:</h4>
          <ul style={{ color: '#666', margin: '0 0 1rem 0', paddingLeft: '1.5rem' }}>
            <li>Micro:bit 보드 2개</li>
            <li>PCA9685 확장 보드</li>
            <li>SG90 서보모터 2개</li>
            <li>타공 막대 및 연결 부품</li>
            <li>USB 케이블</li>
            <li>배터리 팩</li>
          </ul>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#1976d2' }}>소프트웨어:</h4>
          <ul style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li>MakeCode for Micro:bit</li>
            <li>Teachable Machine 또는 TensorFlow.js</li>
            <li>MakeAI Robots 웹사이트</li>
            <li>웹 브라우저 (Chrome 권장)</li>
          </ul>
        </div>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="프로젝트 진행 순서">
          📋 프로젝트 진행 순서
        </h2>
        <p style={{ color: '#666', marginBottom: '1rem' }}>
          프로젝트는 다음 3단계로 진행됩니다. 각 단계를 순서대로 따라해보세요.
        </p>
        
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f0f8ff', marginBottom: '1rem' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#1976d2' }}>단계별 진행:</h4>
          <ol style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li><strong>1단계</strong>: 서보모터 초기 각도 설정 및 로봇 전진 테스트</li>
            <li><strong>2단계</strong>: 포즈학습 AI 모델 준비 및 훈련</li>
            <li><strong>3단계</strong>: AI 모델 연동 후 로봇 주행 테스트</li>
          </ol>
        </div>
        
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#e8f5e8', marginBottom: '1rem' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#2e7d32' }}>🎯 각 단계별 학습 목표:</h4>
          <ul style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li>하드웨어 제어 및 프로그래밍 이해</li>
            <li>AI 모델 개발 및 머신러닝 기초</li>
            <li>실시간 시스템 통합 및 문제해결</li>
          </ul>
        </div>

        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="평가 기준">
          📊 평가 기준
        </h2>
        
        {/* 9월 달력 */}
        <div style={{ 
          border: '1px solid #ddd', 
          borderRadius: '8px', 
          padding: '1rem', 
          backgroundColor: '#f9f9f9',
          marginBottom: '1rem'
        }}>
          <h3 style={{ margin: '0 0 1rem 0', color: '#1976d2', textAlign: 'center' }}>2025년 9월</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(7, 1fr)', 
            gap: '1px', 
            backgroundColor: '#ddd',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            {/* 요일 헤더 */}
            {['일', '월', '화', '수', '목', '금', '토'].map(day => (
              <div key={day} style={{
                backgroundColor: '#e3f2fd',
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '0.9rem'
              }}>
                {day}
              </div>
            ))}
            
            {/* 9월 달력 날짜들 */}
            {Array.from({ length: 35 }, (_, i) => {
              const date = i; // 첫 주 시작을 월요일로 맞춤
              const isCurrentMonth = date > 0 && date <= 30;
              
              // 주차별 정보
              const getWeekInfo = (date: number) => {
                if (date >= 1 && date <= 5) return { week: 1, dayRange: '1~2일차', color: 'rgba(255, 243, 224, 0.7)', textColor: '#d32f2f' };
                if (date >= 8 && date <= 12) return { week: 2, dayRange: '3~4일차', color: 'rgba(15, 194, 226, 0.35)', textColor: '#1976d2' };
                if (date >= 15 && date <= 19) return { week: 3, dayRange: '5~6일차', color: 'rgba(232, 245, 232, 0.7)', textColor: '#1976d2' };
                if (date >= 22 && date <= 26) return { week: 4, dayRange: '7~8일차', color: 'rgba(121, 189, 121, 0.75)', textColor: 'rgba(17, 54, 8, 0.75)' };
                if (date >= 29 && date <= 30) return { week: 5, dayRange: '9~10일차', color: 'rgba(204, 171, 121, 0.7)', textColor: 'rgb(141, 53, 2)' };
                return null;
              };
              
              const weekInfo = getWeekInfo(date);
              const isProjectDay = weekInfo !== null;
              
              return (
                <div key={i} style={{
                  backgroundColor: isCurrentMonth ? (isProjectDay ? weekInfo!.color : 'white') : '#f5f5f5',
                  padding: '0.5rem',
                  textAlign: 'center',
                  minHeight: '80px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  position: 'relative',
                  border: isProjectDay ? '2px solid #1976d2' : 'none',
                  borderRadius: isProjectDay ? '4px' : 'none'
                }}>
                  {isCurrentMonth && (
                    <>
                      <span style={{ 
                        fontSize: '0.9rem',
                        fontWeight: isProjectDay ? 'bold' : 'normal',
                        color: isProjectDay ? weekInfo!.textColor : '#333'
                      }}>
                        {date}
                      </span>
                      {isProjectDay && (
                        <div style={{
                          fontSize: '0.6rem',
                          color: weekInfo!.textColor,
                          marginTop: '2px',
                          textAlign: 'center',
                          lineHeight: '1.2'
                        }}>
                          {weekInfo!.week}주차
                          <br />
                          {weekInfo!.dayRange}
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* 10월 달력 */}
        <div style={{ 
          border: '1px solid #ddd', 
          borderRadius: '8px', 
          padding: '1rem', 
          backgroundColor: '#f9f9f9',
          marginBottom: '1.5rem'
        }}>
          <h3 style={{ margin: '0 0 1rem 0', color: '#1976d2', textAlign: 'center' }}>2025년 10월</h3>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(7, 1fr)', 
            gap: '1px', 
            backgroundColor: '#ddd',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            {/* 요일 헤더 */}
            {['일', '월', '화', '수', '목', '금', '토'].map(day => (
              <div key={day} style={{
                backgroundColor: '#e3f2fd',
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '0.9rem'
              }}>
                {day}
              </div>
            ))}
            
            {/* 10월 달력 날짜들 */}
            {Array.from({ length: 35 }, (_, i) => {
              const date = i - 6 + 4; // 첫 주 시작을 일요일로 맞춤
              const isCurrentMonth = date > 0 && date <= 31;
              
              // 주차별 정보
              const getWeekInfo = (date: number) => {
                if (date >= 1 && date <= 2) return { week: 5, dayRange: '9~10일차', color: 'rgba(204, 171, 121, 0.7)', textColor: 'rgb(141, 53, 2)'  };
                if (date == 3) return { isHoliday: true, dayRange: '개천절', color: 'rgba(255, 251, 5, 0.5)', textColor: 'rgb(255, 7, 7)' };
                if (date >=5 && date <=8) return { isHoliday: true, dayRange: '추석 연휴', color: 'rgba(255, 251, 5, 0.5)', textColor: 'rgb(255, 7, 7)' };
                if (date == 9) return { isHoliday: true, dayRange: '한글날', color: 'rgba(255, 251, 5, 0.5)', textColor: 'rgb(255, 7, 7)' };
                if (date == 10) return { isHoliday: true, dayRange: '재량휴업일', color: 'rgba(255, 251, 5, 0.5)', textColor: 'rgb(255, 7, 7)' };
                if (date >= 13 && date <= 17) return { week: 6, dayRange: '10~11일차', color: 'rgba(232, 245, 232, 0.7)', textColor: '#1976d2' };
                if (date >= 20 && date <= 24) return { week: 7, dayRange: '13~14일차', color: 'rgba(255, 243, 224, 0.7)', textColor: '#d32f2f' };
                return null;
              };
              
              const weekInfo = getWeekInfo(date);
              const isProjectDay = weekInfo !== null;
              
              return (
                <div key={i} style={{
                  backgroundColor: isCurrentMonth ? (isProjectDay ? weekInfo!.color : 'white') : '#f5f5f5',
                  padding: '0.5rem',
                  textAlign: 'center',
                  minHeight: '80px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  position: 'relative',
                  border: isProjectDay ? '2px solid #1976d2' : 'none',
                  borderRadius: isProjectDay ? '4px' : 'none'
                }}>
                  {isCurrentMonth && (
                    <>
                      <span style={{ 
                        fontSize: '0.9rem',
                        fontWeight: isProjectDay ? 'bold' : 'normal',
                        color: isProjectDay ? weekInfo!.textColor : '#333'
                      }}>
                        {date}
                      </span>
                      {isProjectDay && (
                        <div style={{
                          fontSize: '0.6rem',
                          color: weekInfo!.textColor,
                          marginTop: '2px',
                          textAlign: 'center',
                          lineHeight: '1.2'
                        }}>
                          {weekInfo!.isHoliday ? (
                            weekInfo!.dayRange
                          ) : (
                            <>
                              {weekInfo!.week}주차
                              <br />
                              {weekInfo!.dayRange}
                            </>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
          
        <div style={{ marginTop: '1rem', padding: '0.5rem', backgroundColor: '#e8f5e8', borderRadius: '4px' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#2e7d32' }}>📋 주요 일정 안내</h4>
          <ul style={{ margin: 0, paddingLeft: '1.2rem', fontSize: '0.9rem', color: '#555' }}>
            <li><strong>1주차 (1~2일차)</strong>: 자료 조사 및 구조 설계</li>
            <li><strong>2주차 (3~4일차)</strong>: 구조 설계 및 프로토타입 제작</li>
            <li><strong>3주차 (5~6일차)</strong>: 설계도 작성, 프로토타입 제작 및 기계 학습 모델 제작 과정 학습</li>
            <li><strong>4주차 (7~8일차)</strong>: 서보모터 - AI 모델 연결, 전진 테스트</li>
            <li><strong>5주차 (9~10일차)</strong>: 프로토 타입 점검 및 수정, AI 모델 제작</li>
            <li><strong>6주차 (11~12일차)</strong>: 최종 로봇 제작, 주행 테스트</li>
            <li><strong>7주차 (13~14일차)</strong>: 주행 평가 영상 촬영, 발표 영상 제작 및 제출</li>
          </ul>
        </div>
          
        <div style={{ marginTop: '0.5rem', padding: '0.5rem', backgroundColor: '#fff3e0', borderRadius: '4px' }}>
          <p style={{ margin: 0, fontSize: '0.8rem', color: '#e65100' }}>
            💡 <strong>참고사항:</strong> 영상 제출 마감일에 유의해주세요!
          </p>
        </div>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="주행 코스 설명">
          🏁 주행 코스 설명
        </h2>
        
        <img
            src="/images/microbit/AiRobotProject/course.png"
            alt="주행 코스 설명"
            style={{ width: '100%', height: 'auto', borderRadius: '8px', display: 'block', margin: '0 auto' }}
          />
        <p style={{ color: '#666', margin: 0 }}>
          주행 코스는 시작 - 전진 코스 - 장애물 코스 - 3초 일시 정지 코스 - 도착으로 총 5개의 코스로 구성되어 있습니다.<br/>
          주행 목표 시간은 30초 입니다.<br/>
        </p>
        
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '1rem 0 0.5rem 0' }} id="사용 가능한 재료 목록">
          🪛 사용 가능한 재료 목록
        </h2>
        
        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '1rem' }}>
          <tr>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
              src="/images/microbit/AiRobotProject/bar.png"
              alt="타공 막대"
              style={{ width: '30%', height: 'auto' }}
              />
            </td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
                src="/images/microbit/AiRobotProject/servo.png"
                alt="SG90 서보모터"
                style={{ width: '30%', height: 'auto' }}
              />
            </td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>
              <img
                src="/images/microbit/AiRobotProject/bar.png"
                alt="타공 막대"
                style={{ width: '30%', height: 'auto' }}
              />
            </td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
            <td style={{ border: '1px solid #000', padding: '0.5rem' }}>타공 막대</td>
          </tr>
        </table>
        
        <h2 style={{ fontWeight: 'bold', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }} id="서보모터 테스트 하기">
          🤖로봇 제작 및 AI 연동하기
        </h2>
        <p style={{ color: '#666', marginBottom: '1rem' }}>
          로봇 제작 방법은 아래 과정을 확인해주세요.
        </p>
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#f0f8ff', marginBottom: '1rem' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#1976d2' }}>프로젝트 단계별 링크:</h4>
          <ul style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li><a href="/class-materials/Microbit/PCA9685" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', fontWeight: 500 }}><b>1. 서보모터 초기 각도 설정 & 로봇 전진 테스트하기</b></a></li>
            <li><a href="/class-materials/Microbit/PoseLearningAI" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', fontWeight: 500 }}><b>2. 포즈학습 AI 모델 준비하기</b></a></li>
            <li><a href="/class-materials/Microbit/AIRobotControl" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', fontWeight: 500 }}><b>3. AI 모델 연동 후 로봇 주행 테스트하기</b></a></li>
          </ul>
        </div>
        
        <div style={{ padding: '1rem', borderRadius: '8px', backgroundColor: '#fff3cd', marginBottom: '1rem' }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#856404' }}>📊 평가 기준:</h4>
          <ul style={{ color: '#666', margin: 0, paddingLeft: '1.5rem' }}>
            <li><strong>하드웨어 제어</strong> (30점): 서보모터 제어 및 로봇 구조</li>
            <li><strong>AI 모델 개발</strong> (30점): 포즈 인식 모델 훈련 및 정확도</li>
            <li><strong>시스템 통합</strong> (25점): AI 모델과 하드웨어 연동</li>
            <li><strong>창의성 및 완성도</strong> (15점): 프로젝트 완성도 및 창의적 요소</li>
          </ul>
        </div>
      </div>
    );
  };

  export default AIRobotProject;                                                            